import { createIcon } from "@chakra-ui/icons";

export const ArrowUpRightIcon = createIcon({
  displayName: "ArrowUpRightIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M7 17 17 7m0 0H7m10 0v10"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  defaultProps: {
    width: "24px",
    height: "24px",
  },
});
